import React, { useEffect, useState } from "react";
import StyledContentCard from "../../components/styledComponent/styledContentCard";
import CustomTable from "../../components/styledComponent/styledTable";
import { Button, Col, Row, Tag } from "antd";
import { getQuotation, updateQuotation } from "../../server/quotationServices";
import { useNavigate, useParams } from "react-router-dom";
import { ShowNotification } from "../../components/notification/notification";
import "./quotationStyle.css";
import { CiCircleCheck } from "react-icons/ci";
import { RxCrossCircled } from "react-icons/rx";
import { useAppContext } from "../../contexts/appContext";
import { IoDownloadOutline } from "react-icons/io5";
import { StyledButton } from "../../components/styledComponent/styledElements";

export default function QuotationDetails() {
  const productColumn = [
    {
      title: "Code",
      dataIndex: "code",
      key: "code",
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      key: "quantity",
    },
    {
      title: "Unit",
      dataIndex: "unit",
      key: "unit",
    },
    {
      title: "Rate",
      dataIndex: "display_rate",
      key: "display_rate",
    },
    {
      title: "Discount",
      dataIndex: "total_discount",
      key: "total_discount",
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
    },
    {
      title: "Tax",
      dataIndex: "total_tax",
      key: "total_tax",
    },
    {
      title: "Net Amount",
      dataIndex: "net_amount",
      key: "net_amount",
    },
  ];
  const { startLoading, stopLoading, user } = useAppContext();
  const { id } = useParams();
  const navigate = useNavigate();

  const [refetch, setRefetch] = useState(false);
  const [quotationData, setQuotationData] = useState();
  var userRole = user?.role;
  var quotationPermission = user?.access?.quotation;
  const fetchQuotationDetails = async () => {
    startLoading();
    try {
      let res = await getQuotation(id);
      if (!res.data) {
        ShowNotification({ type: "error", message: "Quotation not Found" });
        navigate("/quotation");
      } else {
        setQuotationData(res.data.quotation);
      }
      setRefetch(false);
    } catch (error) {
      console.error(error);
    } finally {
      stopLoading();
    }
  };
  const AcceptQuotation = () => {
    updateQuotation(id, { status: "Accepted" })
      .then((res) => {
        ShowNotification({ type: "success", message: "Quotation Accepted" });
        setRefetch(true);
      })
      .catch((err) => console.error(err));
  };
  const RejectQuotation = () => {
    updateQuotation(id, { status: "Rejected" })
      .then((res) => {
        ShowNotification({ type: "success", message: "Quotation Rejected" });
        setRefetch(true);
      })
      .catch((err) => console.error(err));
  };
  const handleOnImportClick = () => {
    // setShowImportModal(true);
    console.log("Import");
  };
  useEffect(() => {
    fetchQuotationDetails();
  }, [refetch]);
  return (
    <div>
      <StyledContentCard title={"Quotation Details"}>
        <Row className="my-2" justify={"end"}>
          {(userRole === "Admin" ||
            {
              /*importPermission?.create*/
            }) && (
            <StyledButton
              icon={<IoDownloadOutline size={20} />}
              onClick={handleOnImportClick}
              // loading={isImporting}
            >
              {/* {isImporting ? "Importing" : "Import"} */}
              {"Import"}
            </StyledButton>
          )}
        </Row>
        <Row className="my-2" justify={"end"}>
          <Col>
            <Tag
              className="quotation-tag"
              color={
                quotationData?.status === "Accepted"
                  ? "success"
                  : quotationData?.status === "Pending"
                  ? "warning"
                  : "error"
              }
            >
              {quotationData && quotationData.status
                ? quotationData?.status.toUpperCase()
                : "-"}
            </Tag>
          </Col>
          {(userRole === "Admin" || quotationPermission?.edit) && (
            <Col className="content-center">
              <div className="flex justify-center gap-2 content-center">
                <Button
                  className="icon-only-button"
                  icon={
                    <CiCircleCheck
                      size={32}
                      color={
                        quotationData?.status === "Accepted" ? "grey" : "green"
                      }
                    />
                  }
                  onClick={AcceptQuotation}
                  disabled={quotationData?.status === "Accepted"}
                />
                <Button
                  className="icon-only-button"
                  icon={
                    <RxCrossCircled
                      size={32}
                      color={
                        quotationData?.status === "Rejected" ? "grey" : "red"
                      }
                    />
                  }
                  onClick={RejectQuotation}
                  disabled={quotationData?.status === "Rejected"}
                />
              </div>
            </Col>
          )}
        </Row>
        <Row className="my-4">
          <Col span={6}>
            <div className="details-key">Gross Amount</div>
            <div className="details-value">
              {quotationData && quotationData.gross_amount
                ? quotationData.gross_amount
                : 0}
            </div>
          </Col>
          <Col span={6}>
            <div className="details-key">Discount</div>
            <div className="details-value">
              {quotationData && quotationData.total_discount
                ? quotationData.total_discount
                : 0}
            </div>
          </Col>
          <Col span={6}>
            <div className="details-key">Tax</div>
            <div className="details-value">
              {quotationData && quotationData.total_tax
                ? quotationData.total_tax
                : 0}
            </div>
          </Col>
          <Col span={6}>
            <div className="details-key">Grand Total</div>
            <div className="details-value">
              {quotationData && quotationData.grand_total
                ? quotationData.grand_total
                : 0}
            </div>
          </Col>
        </Row>
        <CustomTable columns={productColumn} data={quotationData?.products} />
      </StyledContentCard>
    </div>
  );
}
